import * as yup from 'yup';
import { eCommentType } from '../../types/order/comment/eCommentType';

export const clientCommentFormValidation = () =>
  yup.object({
    orderId: yup.string().required().uuid(),
    content: yup.string().required().min(1),
    relevantParty: yup.string(),
    type: yup.mixed<eCommentType>().oneOf(Object.values(eCommentType)),
  });
